'use client';

import Lenis from 'lenis';
import { useMountEffect } from '@/hooks/useMountEffect';
export function MuseumScroll() {
  useMountEffect(_temp);
  return null;
}
function _temp() {
  const lenis = new Lenis({
    autoRaf: true,
    lerp: 0.1,
    anchors: true
  });
  return () => lenis.destroy();
}